import { mapAppLocale } from '@protector/utils/app-locale-map';
import { setDayjsLocale } from '@protector/utils/dayjs';
import { getCurrentLanguage } from 'core/utils/functions';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const EN_RUNTIME_FORMATS = {
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm'
  }
};

const useUpdateDayjsLocale = () => {
  const [t] = useTranslation();

  useEffect(() => {
    const currentLanguage = getCurrentLanguage();

    if (mapAppLocale(currentLanguage) === 'en') {
      dayjs.updateLocale('en', EN_RUNTIME_FORMATS);
    }

    setDayjsLocale(currentLanguage);
  }, [t]);
};

export default useUpdateDayjsLocale;
